'use strict';

var pill = require('../../../../../../../../../../_virtual/pill.cjs');
require('../../base/accentColors.cjs');
var accentColors = require('../../../../../../../../../../_virtual/accentColors.cjs');

(function (exports) {

	var accentColors$1 = accentColors.__exports;

	exports.PILL_BASE_COLORS = void 0;
	(function(PILL_BASE_COLORS) {
	    PILL_BASE_COLORS["success"] = "success";
	    PILL_BASE_COLORS["system"] = "system";
	    PILL_BASE_COLORS["highlight"] = "highlight";
	    PILL_BASE_COLORS["danger"] = "danger";
	    PILL_BASE_COLORS["warning"] = "warning";
	    PILL_BASE_COLORS["info"] = "info";
	})(exports.PILL_BASE_COLORS || (exports.PILL_BASE_COLORS = {}));
	const PILL_COLORS = {
	    ...exports.PILL_BASE_COLORS,
	    ...accentColors$1.AVIARY_ACCENTS
	};

	exports.PILL_COLORS = PILL_COLORS;
	
} (pill.__exports));
//# sourceMappingURL=pill.cjs.map
